export enum PublishedSurveyTab {
  Questions = 'Questions',
  Answers = 'Answers',
  Publication = 'Publication',
}
